import { formatSecondsToHumanReadableTimestamp } from 'util/time';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { selectRecordingDuration } from 'state/selectors';
import { SizeVariant } from 'ui/components/ControlButton/types';
import { RecordInProgressText } from './view';

interface RecordProgressDataProps {
    buttonSize?: SizeVariant;
}

export const RecordProgressData = React.memo(({ buttonSize }: RecordProgressDataProps) => {
    const { t } = useTranslation();
    const [time, setTime] = useState(() => selectRecordingDuration());

    useEffect(() => {
        const interval = setInterval(() => {
            setTime((time) => time + 1);
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, []);

    const formattedTime = formatSecondsToHumanReadableTimestamp(time);
    const recordText =
        buttonSize === 'small' ? formattedTime : t('web_call_record_start_video_indicator', { 0: formattedTime });

    return <RecordInProgressText variant="caption4">{recordText}</RecordInProgressText>;
});
